import {
   Tabs,
   TabList,
   Tab,
   TabPanels,
   TabPanel,
   Text,
   Input,
   InputGroup,
   InputRightElement,
   FormLabel,
   InputLeftElement,
} from '@chakra-ui/react';
import { useLocalization } from '~/framework';
import { TeamSearchInput } from '~/pages/_shared/TeamSearchInput';
import { UserSearchInput } from '~/pages/Courses/_shared/UserSearchInput';
import { CourseAssignmentOptions } from './CourseAssignmentOptions';
import { Icon } from '~/ui-components';
import { faEdit, faLoader } from '@fortawesome/pro-regular-svg-icons';
import { useUser, useTeam } from '~/pages/_shared';

type AssignmentAssigneeInputProps = {
   assignment: CourseAssignmentOptions;
   onChange: (assignment: CourseAssignmentOptions) => void;
};

export function AssignmentAssigneeInput({ assignment, onChange }: AssignmentAssigneeInputProps) {
   const { _js } = useLocalization();

   function assignUser(userid: number) {
      onChange({
         ...assignment,
         assignee_teamid: null,
         assignee_userid: userid,
      });
   }

   function assignTeam(teamid: number) {
      onChange({
         ...assignment,
         assignee_teamid: teamid,
         assignee_userid: null,
      });
   }

   function clearAssignee() {
      onChange({
         ...assignment,
         assignee_teamid: null,
         assignee_userid: null,
      });
   }

   const { data: assignedUser } = useUser(assignment.assignee_userid);
   const { data: assignedTeam } = useTeam(assignment.assignee_teamid);

   const hasAssignee = assignment.assignee_teamid ?? assignment.assignee_userid;

   let assigneeName = null;
   if (assignedUser) {
      assigneeName = assignedUser.username;
   }
   if (assignedTeam) {
      assigneeName = assignedTeam.name;
   }

   return hasAssignee ? (
      <>
         <FormLabel>{_js('Assignee')}</FormLabel>
         <InputGroup cursor="pointer" aria-label={_js('Edit Assignee')} onClick={clearAssignee}>
            {!assigneeName && (
               <InputLeftElement>
                  <Icon type={faLoader} spin />
               </InputLeftElement>
            )}
            <Input readOnly pointerEvents="none" value={assigneeName || ''} />;
            <InputRightElement>
               <Icon type={faEdit} />
            </InputRightElement>
         </InputGroup>
      </>
   ) : (
      <>
         <Text variant="muted">{_js('Select a user or team to assign the course to')}:</Text>
         <Tabs mt={4} isLazy>
            <TabList>
               <Tab>{_js('Team')}</Tab>
               <Tab>{_js('User')}</Tab>
            </TabList>
            <TabPanels>
               <TabPanel>
                  <TeamSearchInput onChange={assignTeam} />
               </TabPanel>
               <TabPanel>
                  <UserSearchInput onChange={assignUser} />
               </TabPanel>
            </TabPanels>
         </Tabs>
      </>
   );
}
